<template>
    <div class="container">
        <div class="head">
            <comm-head></comm-head>
        </div>
        <div class="content">
            <div class="title">{{ title }}</div>
            <div class="source_time">
                <div class="source">来源： {{source == "" ? "杭州多麦电子商务股份有限公司" : source}}</div>
                <div class="time">时间： {{time}}</div>
            </div>
            <div class="detail">
                <div v-html="content" class="news_detail"></div>
            </div>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import commHead from '@/components/comm-head.vue'
import footCpright from '@/components/foot-cpright.vue'
export default {
    name: "Detail",
    data() {
        return {
            content: "",
            title: "",
            source: "",
            time: ""
        };
    },
    components: {
        commHead,
        footCpright,
    },
    mounted() {
        this.$http
            .get("site/news-detail", {
                params: {
                    NewsID: this.$route.query.id
                }
            })
            .then(response => {
                this.content = response.d["Content"];
                this.title = response.d["Title"];
                this.source = response.d["Src"];
                this.time = response.d["CreateTime"];
            });
    }
};
</script>

<style lang="scss" scoped>
.head {
    background-color: #161c2a;
}
.content {
    background-color: #fff;
    min-height: 839px;
}
.title {
    text-align: center;
    font-size: 24px;
    padding: 80px 20px 20px;
}
.source_time {
    text-align: center;
    color: #666;
}
.source {
    display: inline;
    margin-right: 50px;
}
.time {
    display: inline;
}
.detail {
    width: 880px;
    margin: 0 auto;
    padding: 30px 0;
}
.news_detail {
    width: 100%;
    & /deep/ h3 {
        font-size: 18px;
        color: #333;
        text-align: center;
        height: 35px;
        line-height: 35px;
        border-bottom: 1px solid #eee;
        font-weight: normal;
    }
    & /deep/ i {
        color: #999;
        padding-right: 40px;
        float: right;
        height: 35px;
        line-height: 35px;
        font-style: normal;
        float: left;
    }
    & /deep/ p {
        clear: both;
        line-height: 24px;
        padding-top: 10px;
        text-indent: 2em;
        font-size: 14px;
        & img {
            width: 800px;
            display: block;
            margin:0 auto;
        }
    }
    & /deep/ img {
        padding: 5px;
    }
    & /deep/ video {
        width: 100%;
    }
}
</style>
